import http from 'utils/http';
import { AlternativeNameItem, Item, UpsellAndCrossSell } from './types';
import {
  getAllItemsUrl,
  getAlternativeNamesUrl,
  getAlternativeNameUrl,
  getMenuItemModifiersUrl,
  getMenuItemsUrl,
  getMenuOptionsUrl,
  getUpSellAndCrossSellsUrl,
  getUpSellAndCrossSellUrl,
  updateMenuUrl
} from './apiUrls';

export function getUpSellAndCrossSells(
  integrationId: number,
  params?: Record<string, any>
): Promise<{ data: UpsellAndCrossSell[] }> {
  return http.get(getUpSellAndCrossSellsUrl(integrationId), params);
}

export function getUpSellAndCrossSell(
  integrationId: number,
  upSellAndCrossSellId: number,
  params?: Record<string, any>
): Promise<UpsellAndCrossSell> {
  return http.get(getUpSellAndCrossSellUrl(integrationId, upSellAndCrossSellId), params);
}

export function createUpSellAndCrossSell(
  integrationId: number,
  upSellAndCrossSellId: number,
  payload: any
): Promise<any> {
  return http.post(getUpSellAndCrossSellsUrl(integrationId), payload);
}

export function updateUpSellAndCrossSell(
  integrationId: number,
  upSellAndCrossSellId: number,
  payload: any
): Promise<any> {
  return http.patch(getUpSellAndCrossSellUrl(integrationId, upSellAndCrossSellId), payload);
}

export function deleteUpSellAndCrossSell(
  integrationId: number,
  upSellAndCrossSellId: number
): Promise<{ meta: { message: string } }> {
  return http.delete(getUpSellAndCrossSellUrl(integrationId, upSellAndCrossSellId));
}

export function getMenuOptions(locationId: number, params?: Record<string, any>): Promise<{ data: Item[] }> {
  return http.get(getMenuOptionsUrl(locationId), params);
}

export function updatePosMenu(
  locationId: number,
  menuId: number,
  payload: { menu: { offer_menu: boolean } }
): Promise<{ data: Item }> {
  return http.patch(updateMenuUrl(locationId, menuId), payload);
}

export function getPosMenu(locationId: number, menuId: number): Promise<unknown> {
  return http.get(updateMenuUrl(locationId, menuId));
}

export function getMenuItems(
  locationId: number,
  menuId: number,
  params?: Record<string, any>
): Promise<{ data: Item[] }> {
  return http.get(getMenuItemsUrl(locationId, menuId), { ...params });
}

export function getMenuItemModifiers(
  locationId: number,
  menuId: number,
  menuItemId: number,
  params?: Record<string, any>
): Promise<{ data: Item[] }> {
  return http.get(getMenuItemModifiersUrl(locationId, menuId, menuItemId), params);
}

export function getAllItems(locationId: number, params?: Record<string, any>): Promise<{ data: Item[] }> {
  return http.get(getAllItemsUrl(locationId), params);
}

export function getAlternativeNames(
  integrationId: number,
  params?: Record<string, any>
): Promise<{ data: AlternativeNameItem[] }> {
  return http.get(getAlternativeNamesUrl(integrationId), params);
}
export function getAlternativeName(
  integrationId: number,
  alternativeNameId: number,
  params?: Record<string, any>
): Promise<AlternativeNameItem> {
  return http.get(getAlternativeNameUrl(integrationId, alternativeNameId), params);
}

export function createAlternativeName(integrationId: number, payload: any): Promise<AlternativeNameItem> {
  return http.post(getAlternativeNamesUrl(integrationId), payload);
}

export function updateAlternativeName(
  integrationId: number,
  alternativeNameId: number,
  payload: any
): Promise<AlternativeNameItem> {
  return http.patch(getAlternativeNameUrl(integrationId, alternativeNameId), payload);
}

export function deleteAlternativeName(
  integrationId: number,
  alternativeNameId: number
): Promise<{ meta: { message: string } }> {
  return http.delete(getAlternativeNameUrl(integrationId, alternativeNameId));
}
